import { render, staticRenderFns } from "./PracticePlans.vue?vue&type=template&id=4dcc782c"
import script from "./PracticePlans.vue?vue&type=script&lang=js"
export * from "./PracticePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports